export const createNewPasswordFormFields = [
    {
        tagType: "regular",
        label: "Create new password",
        id: "password",
        name: "password",
        type: "password",
        placeholder: "Enter your new password",
    },
    {
        tagType: "regular",
        label: "Confirm your new password",
        id: "confPassword",
        name: "confPassword",
        type: "password",
        placeholder: "Confirm your new password",
    }
]